import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ClientDtoKeysEnum } from '@zaoblako/shared/modules/client/enums/client-dto-keys.enum';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';

import * as yup from 'yup';

/** Response body for activity */
export interface ActivityFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;
  /** Activity name */
  name: string;
  /** Activity description */
  description?: string;
  /** Activity soft deletion date and time */
  deleted?: Date;
  /** Contragents */
  contragents: ContragentFindInterface[];
}

/** Response body for activity. DTO schema */
export const ActivityFindDto = SerdeDtoClass.create<ActivityFindInterface>(ClientDtoKeysEnum.ACTIVITY_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  name: {
    label: 'Название',
    serializer: yup.string(),
  },
  description: {
    optional: true,
    label: 'Описание',
    serializer: yup.string(),
  },
  deleted: {
    label: 'Удален',
    optional: true,
    serializer: yup.date(),
  },
  contragents: {
    label: 'Контрагенты',
    optional: true,
    nested: ClientDtoKeysEnum.CONTRAGENT_FIND_DTO,
    serializer: (_, nested) => yup.array(nested),
  },
});
